import React, { FC, useCallback } from 'react';

import { useIntl } from 'react-intl-next';

import { Text } from '@atlaskit/primitives';

import { MergeCheck } from 'src/types';

import { ForgeMergeCheckResult } from '../..';
import { ClassicMergeCheckName } from '../../classic-merge-check-name';
import { isClassicMergeCheck, isForgeMergeCheckResult } from '../../utils';
import { mergeCheckResultComparator } from '../utils';

import { messages } from './i18n';
import { MergeChecksListWrapper } from './styled';

type MergeChecksListProps = {
  customMergeCheckResults: ForgeMergeCheckResult[];
  classicMergeCheckResults?: MergeCheck[];
};

/* eslint @typescript-eslint/ban-types: "warn" */
export const BasicMergeChecksList: FC<MergeChecksListProps> = ({
  customMergeCheckResults,
  classicMergeCheckResults = [],
}) => {
  const { formatMessage } = useIntl();

  const allResults = [
    ...customMergeCheckResults,
    ...classicMergeCheckResults,
  ].sort(mergeCheckResultComparator);

  const renderResult = useCallback(
    (result: ForgeMergeCheckResult | MergeCheck) => {
      if (isForgeMergeCheckResult(result)) {
        return (
          <Text maxLines={2}>
            {formatMessage(messages.mergeCheckLabel, {
              checkName: result.check.name,
              targetBranchLabel:
                result.branchConfig.identifier !== 'all_branches'
                  ? formatMessage(messages.mergeCheckTargetBranchLabel, {
                      branchName: result.branchConfig.identifier,
                    })
                  : '',
            })}
          </Text>
        );
      }

      if (isClassicMergeCheck(result)) {
        return <ClassicMergeCheckName check={result} />;
      }

      return null;
    },
    [formatMessage]
  );

  return (
    <MergeChecksListWrapper>
      {allResults.map((result, index) => (
        <li key={index.toString()}>{renderResult(result)}</li>
      ))}
    </MergeChecksListWrapper>
  );
};
